import React, { useEffect, useState } from "react";
import { modalBoxStyle } from "../styles";
import {
  Button,
  Typography,
  Box,
  Modal,
  Grid,
  IconButton,
  TextField,
  CircularProgress,
} from "@mui/material";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";

const EditFamilyModal = ({
  isOpen,
  toggleModalOpen,
  headerText,
  item,
  handlePatch
}) => {
  const [itemName, setItemName] = useState("");
  const [isLoading, toggleIsLoading] = useState(false);

  useEffect(() => {
    setItemName(item?.name);
  }, [item]);

  const closeModal = () => {
    toggleIsLoading(false);
    toggleModalOpen(false);
  };

  const handleNameChange = (e) => {
    setItemName(e.target.value);
  };

  const handleSubmit = async () => {
    toggleIsLoading(true);
    await handlePatch(itemName);
    closeModal();
  }

  return (
    <Modal
      open={isOpen}
      onClose={closeModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={modalBoxStyle}>
        <form>
          <Grid
            container
            direction="column"
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Grid
              container
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Grid item>
                <Typography variant="h2">{headerText}</Typography>
              </Grid>
              <Grid item>
                <IconButton onClick={closeModal}>
                  <CloseOutlinedIcon />
                </IconButton>
              </Grid>
            </Grid>
            <Box sx={{ marginTop: 8, width: "100%" }}>
              <TextField
                size="small"
                required
                fullWidth
                value={itemName}
                label="Name"
                InputLabelProps={{ shrink: true }}
                onChange={handleNameChange}
              />
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                marginTop: "3rem",
              }}
            >
              {isLoading ? (
                <CircularProgress />
              ) : (
                <Button
                  disabled={!itemName}
                  variant="contained"
                  onClick={handleSubmit}
                  sx={{
                    width: "300px",
                    height: "40px",
                    borderRadius: 2,
                    paddingTop: 2,
                    paddingBottom: 2,
                    paddingLeft: 6,
                    paddingRight: 6,
                  }}
                >
                  <Typography variant="largeButton">Save Details</Typography>
                </Button>
              )}
            </Box>
          </Grid>
        </form>
      </Box>
    </Modal>
  );
};

export default EditFamilyModal;
